// src/pages/ShopPage/ShopPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import './ShopPage.css';
import { FaDiscord } from 'react-icons/fa';


const ShopPage = () => {
  const [isShopComingSoon] = useState(true);
  const cardRef = useRef(null);

  const [typedText, setTypedText] = useState('');
  const fullText = "ㅤㅤUn nuevo mundo de productos está a punto de abrirse, ¡prepárate!";

  useEffect(() => {
    if (isShopComingSoon) {
      let i = 0;
      setTypedText('');
      const typingInterval = setInterval(() => {
        if (i < fullText.length) {
          setTypedText(prev => prev + fullText.charAt(i));
          i++;
        } else {
          clearInterval(typingInterval);
        }
      }, 50);
      return () => clearInterval(typingInterval);
    }
  }, [isShopComingSoon, fullText]);

  useEffect(() => {
    if (isShopComingSoon && cardRef.current) {
      cardRef.current.classList.remove('fade-in-up-anim');
      void cardRef.current.offsetWidth;
      cardRef.current.classList.add('fade-in-up-anim');
    }
  }, [isShopComingSoon]);

  if (isShopComingSoon) {
    return (
      <div className="shop-page-container soon-mode">
        <div className="shop-overlay"></div>
        <div ref={cardRef} className="shop-coming-soon-card">
          <h1 className="shop-coming-soon-title">
            Tienda <span>Próximamente</span>
          </h1>
          
          <div className="shop-accent-line" />
          
          <p className="shop-typing-text">
            {typedText}
          </p>

          <div className="shop-actions">
            <button
              className="shop-discord-btn"
              onClick={() => window.open('https://discord.gg/e4EWKCxVB4', '_blank')}
            >
              <FaDiscord /> Únete a Discord
            </button>
          </div>

          <div className="shop-hint">
            Síguenos para enterarte antes que nadie
          </div>
        </div>
      </div>
    );
  }


  // Contenido de la tienda normal
  return (
    <div className="shop-page-container normal-mode">
      <section className="shop-hero">
        <h1>¡Bienvenido a Nuestra Tienda!</h1>
        <p>Explora nuestra colección de productos exclusivos.</p>
        <button className="shop-button">Ver Productos</button>
      </section>
      <section className="featured-products">
        <h2>Productos Destacados</h2>
        <div className="product-grid">
          <div className="product-card">
            <img src="https://via.placeholder.com/150" alt="Producto 1" className="product-image" />
            <h3>Nombre del Producto 1</h3>
            <p className="product-price">€29.99</p>
            <button className="add-to-cart">Añadir al Carrito</button>
          </div>
          <div className="product-card">
            <img src="https://via.placeholder.com/150" alt="Producto 2" className="product-image" />
            <h3>Nombre del Producto 2</h3>
            <p className="product-price">€39.99</p>
            <button className="add-to-cart">Añadir al Carrito</button>
          </div>
        </div>
      </section>
      <section className="shop-categories">
        <h2>Categorías</h2>
        <ul>
          <li>Electrónica</li>
          <li>Ropa</li>
          <li>Hogar</li>
          <li>Gaming</li>
        </ul>
      </section>
    </div>
  );
};

export default ShopPage;

// Al final del archivo o en el CSS global:
// .fade-in-up-anim { animation: fadeInUp 0.8s cubic-bezier(0.23, 1, 0.32, 1); }
// @keyframes fadeInUp { 0% { opacity: 0; transform: translateY(40px); } 100% { opacity: 1; transform: translateY(0); } }